/** RHF v5 field arrays store object rows; both task publication paths send string options. */
export function getPollOptionLabels(options?: (string | { value?: string })[]): string[] {
  return (options ?? []).map((option) => (typeof option === 'string' ? option : option.value ?? ''))
}
